import React, { useEffect, useState } from 'react'
import { RichText as BaseRichText } from '@superrb/gatsby-addons/components'
import { RichText as RichTextType } from '@superrb/gatsby-addons/types'
import { renderToString } from 'react-dom/server'
import { PrismicRichText } from '@prismicio/react'

interface Props {
  field: RichTextType['richText']
  className?: string
}

export const RichText = ({ field, className = '' }: Props) => {
  let isQuote = false
  let quoteHTML = ''

  const [formatted, setFormatted] = useState<Props['field']>([])
  useEffect(() => {
    setFormatted(
      field
        ?.map((item: { type: string; text: string }) => {
          if (isQuote && item.text !== '{{/quote}}') {
            if (item.text.startsWith('{{author')) {
              const matches = item.text.match(/(?:\{\{author\ )(.*)(?:\}\})/)
              const author = matches[1] ?? null

              if (author) {
                quoteHTML += `<cite>${author}</cite>`
                return null
              }
            }

            quoteHTML += renderToString(<PrismicRichText field={[item]} />)
            return null
          }

          if (item.text === '---') {
            return {
              ...item,
              type: 'embed',
              oembed: {
                embed_url: '',
                provider_name: '',
                html: '<hr />',
              },
            }
          }

          if (item.text === '{{quote}}') {
            isQuote = true
            return null
          }

          if (item.text === '{{/quote}}') {
            const embed = {
              ...item,
              type: 'embed',
              oembed: {
                embed_url: '',
                provider_name: '',
                html: `
                <blockquote>
                  ${quoteHTML}
                </blockquote>
              `,
              },
            }
            isQuote = false
            quoteHTML = ''
            return embed
          }

          return item
        })
        .filter(item => item !== null),
    )
  }, [field])

  return <BaseRichText field={formatted} className={`rich-text ${className}`} />
}

export default RichText
